import {
    SOCIETY_WINGS_LIST,
    SOCIETY_WINGS_LIST_SUCCESS,
    SOCIETY_WINGS_LIST_FAILURE,
    SOCIETY_CREATE_WINGS,
    SOCIETY_CREATE_WINGS_SUCCESS,
    SOCIETY_CREATE_WINGS_FAILURE,
    SOCIETY_EDIT_WINGS,
    SOCIETY_EDIT_WINGS_SUCCESS,
    SOCIETY_EDIT_WINGS_FAILURE,
    SOCIETY_DELETE_WINGS,
    SOCIETY_DELETE_WINGS_SUCCESS,
    SOCIETY_DELETE_WINGS_FAILURE,

    SOCIETY_FLATS_LIST,
    SOCIETY_FLATS_LIST_SUCCESS,
    SOCIETY_FLATS_LIST_FAILURE,
    SOCIETY_CREATE_FLATS,
    SOCIETY_CREATE_FLATS_SUCCESS,
    SOCIETY_CREATE_FLATS_FAILURE,
    SOCIETY_EDIT_FLATS,
    SOCIETY_EDIT_FLATS_SUCCESS,
    SOCIETY_EDIT_FLATS_FAILURE,
    SOCIETY_DELETE_FLATS,
    SOCIETY_DELETE_FLATS_SUCCESS,
    SOCIETY_DELETE_FLATS_FAILURE,

    SOCIETY_WINGS_DROPDOWN,
    SOCIETY_WINGS_DROPDOWN_SUCCESS,
    SOCIETY_WINGS_DROPDOWN_FAILURE,
    SOCIETY_FLATS_DROPDOWN,
    SOCIETY_FLATS_DROPDOWN_SUCCESS,
    SOCIETY_FLATS_DROPDOWN_FAILURE,

    SOCIETY_FLATS_WITH_OWNERSHIP,
    SOCIETY_FLATS_WITH_OWNERSHIP_SUCCESS,
    SOCIETY_FLATS_WITH_OWNERSHIP_FAILURE,

    SOCIETY_BULK_UPLOAD_WINGS,
    SOCIETY_BULK_UPLOAD_WINGS_SUCCESS,
    SOCIETY_BULK_UPLOAD_WINGS_FAILURE,
    SOCIETY_CLEAR_WINGS_BULK_UPLOAD_STATE,

    SOCIETY_BULK_UPLOAD_FLATS,
    SOCIETY_BULK_UPLOAD_FLATS_SUCCESS,
    SOCIETY_BULK_UPLOAD_FLATS_FAILURE,
    SOCIETY_CLEAR_FLATS_BULK_UPLOAD_STATE,
} from "../../actions/index.types";
const initialState = {
    // Wings
    wingsList: null,
    wingsPagination: null,
    wingsLoading: false,
    wingsCreateLoading: false,
    wingsEditLoading: false,
    wingsDeleteLoading: false,

    // Flats
    flatsList: null,
    flatsPagination: null,
    flatsStats: null,
    flatsLoading: false,
    flatsCreateLoading: false,
    flatsEditLoading: false,
    flatsDeleteLoading: false,

    // Dropdowns
    wingsDropdown: [],
    wingsDropdownLoading: false,
    flatsDropdown: [],
    flatsDropdownLoading: false,

    // Flats with Ownership
    flatsWithOwnership: [],
    flatsWithOwnershipLoading: false,

    // Bulk Upload
    wingsBulkUploadLoading: false,
    wingsBulkUploadResult: null,
    flatsBulkUploadLoading: false,
    flatsBulkUploadResult: null,

    // Common
    error: null,
};

const WingsAndFlatsReducers = (state = initialState, action) => {
    switch (action.type) {

        /* =========================
           WINGS LIST
        ========================= */
        case SOCIETY_WINGS_LIST:
            return {
                ...state,
                wingsLoading: true,
                error: null,
            };

        case SOCIETY_WINGS_LIST_SUCCESS:
            return {
                ...state,
                wingsLoading: false,
                wingsList: action.payload?.data || action.payload,
                wingsPagination: action.payload?.pagination || null,
                error: null,
            };

        case SOCIETY_WINGS_LIST_FAILURE:
            return {
                ...state,
                wingsLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           CREATE WINGS
        ========================= */
        case SOCIETY_CREATE_WINGS:
            return {
                ...state,
                wingsCreateLoading: true,
                error: null,
            };

        case SOCIETY_CREATE_WINGS_SUCCESS:
            return {
                ...state,
                wingsCreateLoading: false,
                error: null,
            };

        case SOCIETY_CREATE_WINGS_FAILURE:
            return {
                ...state,
                wingsCreateLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           EDIT WINGS
        ========================= */
        case SOCIETY_EDIT_WINGS:
            return {
                ...state,
                wingsEditLoading: true,
                error: null,
            };

        case SOCIETY_EDIT_WINGS_SUCCESS:
            return {
                ...state,
                wingsEditLoading: false,
                error: null,
            };

        case SOCIETY_EDIT_WINGS_FAILURE:
            return {
                ...state,
                wingsEditLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           DELETE WINGS
        ========================= */
        case SOCIETY_DELETE_WINGS:
            return {
                ...state,
                wingsDeleteLoading: true,
                error: null,
            };

        case SOCIETY_DELETE_WINGS_SUCCESS:
            return {
                ...state,
                wingsDeleteLoading: false,
                error: null,
            };

        case SOCIETY_DELETE_WINGS_FAILURE:
            return {
                ...state,
                wingsDeleteLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           FLATS LIST
        ========================= */
        case SOCIETY_FLATS_LIST:
            return {
                ...state,
                flatsLoading: true,
                error: null,
            };

        case SOCIETY_FLATS_LIST_SUCCESS:
            return {
                ...state,
                flatsLoading: false,
                flatsList: action.payload?.data || action.payload,
                flatsPagination: action.payload?.pagination || null,
                flatsStats: action.payload?.stats || null,
                error: null,
            };

        case SOCIETY_FLATS_LIST_FAILURE:
            return {
                ...state,
                flatsLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           CREATE FLATS
        ========================= */
        case SOCIETY_CREATE_FLATS:
            return {
                ...state,
                flatsCreateLoading: true,
                error: null,
            };

        case SOCIETY_CREATE_FLATS_SUCCESS:
            return {
                ...state,
                flatsCreateLoading: false,
                error: null,
            };

        case SOCIETY_CREATE_FLATS_FAILURE:
            return {
                ...state,
                flatsCreateLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           EDIT FLATS
        ========================= */
        case SOCIETY_EDIT_FLATS:
            return {
                ...state,
                flatsEditLoading: true,
                error: null,
            };

        case SOCIETY_EDIT_FLATS_SUCCESS:
            return {
                ...state,
                flatsEditLoading: false,
                error: null,
            };

        case SOCIETY_EDIT_FLATS_FAILURE:
            return {
                ...state,
                flatsEditLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           DELETE FLATS
        ========================= */
        case SOCIETY_DELETE_FLATS:
            return {
                ...state,
                flatsDeleteLoading: true,
                error: null,
            };

        case SOCIETY_DELETE_FLATS_SUCCESS:
            return {
                ...state,
                flatsDeleteLoading: false,
                error: null,
            };

        case SOCIETY_DELETE_FLATS_FAILURE:
            return {
                ...state,
                flatsDeleteLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           WINGS DROPDOWN
        ========================= */
        case SOCIETY_WINGS_DROPDOWN:
            return {
                ...state,
                wingsDropdownLoading: true,
            };

        case SOCIETY_WINGS_DROPDOWN_SUCCESS:
            return {
                ...state,
                wingsDropdownLoading: false,
                wingsDropdown: action.payload || [],
            };

        case SOCIETY_WINGS_DROPDOWN_FAILURE:
            return {
                ...state,
                wingsDropdownLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           FLATS DROPDOWN
        ========================= */
        case SOCIETY_FLATS_DROPDOWN:
            return {
                ...state,
                flatsDropdownLoading: true,
            };

        case SOCIETY_FLATS_DROPDOWN_SUCCESS:
            return {
                ...state,
                flatsDropdownLoading: false,
                flatsDropdown: action.payload || [],
            };

        case SOCIETY_FLATS_DROPDOWN_FAILURE:
            return {
                ...state,
                flatsDropdownLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           FLATS WITH OWNERSHIP
        ========================= */
        case SOCIETY_FLATS_WITH_OWNERSHIP:
            return {
                ...state,
                flatsWithOwnershipLoading: true,
            };

        case SOCIETY_FLATS_WITH_OWNERSHIP_SUCCESS:
            return {
                ...state,
                flatsWithOwnershipLoading: false,
                flatsWithOwnership: action.payload || [],
            };

        case SOCIETY_FLATS_WITH_OWNERSHIP_FAILURE:
            return {
                ...state,
                flatsWithOwnershipLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           BULK UPLOAD — WINGS
        ========================= */
        case SOCIETY_BULK_UPLOAD_WINGS:
            return { ...state, wingsBulkUploadLoading: true, wingsBulkUploadResult: null };
        case SOCIETY_BULK_UPLOAD_WINGS_SUCCESS:
            return { ...state, wingsBulkUploadLoading: false, wingsBulkUploadResult: action.payload || { success: true } };
        case SOCIETY_BULK_UPLOAD_WINGS_FAILURE:
            return { ...state, wingsBulkUploadLoading: false, wingsBulkUploadResult: { success: false, message: action?.message } };
        case SOCIETY_CLEAR_WINGS_BULK_UPLOAD_STATE:
            return { ...state, wingsBulkUploadLoading: false, wingsBulkUploadResult: null };

        /* =========================
           BULK UPLOAD — FLATS
        ========================= */
        case SOCIETY_BULK_UPLOAD_FLATS:
            return { ...state, flatsBulkUploadLoading: true, flatsBulkUploadResult: null };
        case SOCIETY_BULK_UPLOAD_FLATS_SUCCESS:
            return { ...state, flatsBulkUploadLoading: false, flatsBulkUploadResult: action.payload || { success: true } };
        case SOCIETY_BULK_UPLOAD_FLATS_FAILURE:
            return { ...state, flatsBulkUploadLoading: false, flatsBulkUploadResult: { success: false, message: action?.message } };
        case SOCIETY_CLEAR_FLATS_BULK_UPLOAD_STATE:
            return { ...state, flatsBulkUploadLoading: false, flatsBulkUploadResult: null };

        default:
            return state;
    }
};

export default WingsAndFlatsReducers;
